import { useState } from 'react';
import { Mail, MessageCircle, LifeBuoy, ArrowRight } from 'lucide-react';

import PageHero from '../components/PageHero';
import Reveal from '../components/Reveal';
import Container from './Main/sections/Container';

const CHANNELS = [
  {
    icon: Mail,
    title: 'Email us',
    desc: 'We reply to every message within 24 hours.',
    action: 'info@schoolhack.ai',
    href: 'mailto:info@schoolhack.ai',
  },
  {
    icon: MessageCircle,
    title: 'Join our Discord',
    desc: 'Chat with the team and thousands of students.',
    action: 'discord.gg/schoolhack',
    href: 'https://discord.gg/schoolhack',
  },
  {
    icon: LifeBuoy,
    title: 'Help centre',
    desc: 'Browse guides and answers to common questions.',
    action: 'Visit the app',
    href: 'https://app.schoolhack.ai',
  },
];

const Contactus = () => {
  const [name, setName] = useState('');
  const [question, setQuestion] = useState('');
  const [body, setBody] = useState('');

  const disabled = !name || !question || !body;

  const onClickSendMessage = (e) => {
    if (disabled) e.preventDefault();
  };

  const inputClass =
    'w-full rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3 text-[0.95rem] text-white outline-none transition-colors placeholder:text-white/30 focus:border-accent/50';

  return (
    <>
      <PageHero
        eyebrow="Get in Touch"
        title="We'd Love To"
        titleAccent="Hear From You"
        subtitle="Questions, feedback, or just want to say hello? Send us a message and the team will get back to you."
      />

      <section className="relative pb-24">
        <Container className="grid items-start gap-10 lg:grid-cols-[1fr_1.1fr]">
          {/* channels */}
          <div className="flex flex-col gap-4">
            {CHANNELS.map((c, i) => (
              <Reveal key={c.title} delay={i * 90}>
                <a
                  href={c.href}
                  target="_blank"
                  rel="noreferrer"
                  className="glass glass-hover group flex items-start gap-4 rounded-2xl p-5"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent/12 text-accent">
                    <c.icon size={20} />
                  </span>
                  <div>
                    <h3 className="font-heading text-[1.05rem] font-semibold text-white">
                      {c.title}
                    </h3>
                    <p className="mt-1 text-[0.85rem] text-white/50">{c.desc}</p>
                    <span className="mt-2 inline-flex items-center gap-1.5 text-[0.85rem] font-medium text-accent">
                      {c.action}
                      <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                    </span>
                  </div>
                </a>
              </Reveal>
            ))}
          </div>

          {/* form */}
          <Reveal delay={120}>
            <div className="glass rounded-3xl p-6 md:p-8">
              <h2 className="font-heading text-[1.5rem] font-semibold text-white">
                Send us a message
              </h2>
              <p className="mt-2 text-[0.9rem] text-white/50">
                Fill in the form and we&apos;ll open your email client to send it our
                way.
              </p>

              <div className="mt-6 flex flex-col gap-4">
                <div>
                  <label className="mb-1.5 block text-[0.82rem] font-medium text-white/70">
                    Full name
                  </label>
                  <input
                    aria-label="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Jane Doe"
                    className={inputClass}
                  />
                </div>
                <div>
                  <label className="mb-1.5 block text-[0.82rem] font-medium text-white/70">
                    What is this about?
                  </label>
                  <input
                    aria-label="title"
                    value={question}
                    onChange={(e) => setQuestion(e.target.value)}
                    placeholder="e.g. Feedback, partnership, support…"
                    className={inputClass}
                  />
                </div>
                <div>
                  <label className="mb-1.5 block text-[0.82rem] font-medium text-white/70">
                    Message
                  </label>
                  <textarea
                    aria-label="message"
                    rows={5}
                    value={body}
                    onChange={(e) => setBody(e.target.value)}
                    placeholder="Tell us how we can help…"
                    className={`${inputClass} resize-none`}
                  />
                </div>

                <a
                  onClick={onClickSendMessage}
                  target="blank"
                  rel="noopener noreferrer nofollow"
                  href={`mailto:info@schoolhack.ai?subject=${`${name}, ${question}`}&body=${body}`}
                  className={`btn-primary mt-2 w-full px-6 py-3.5 text-[0.95rem] ${
                    disabled ? 'pointer-events-none opacity-50' : ''
                  }`}
                >
                  Send message
                  <ArrowRight size={16} />
                </a>
              </div>
            </div>
          </Reveal>
        </Container>
      </section>
    </>
  );
};

export default Contactus;
